import React from "react";

export default function FormItem({
  product,
  handleProductSelection,
  navigateTo,
}) {
  return (
    <>
      <div className=" rounded-lg bg-white my-auto shadow mx-auto z-10">
        <button
          onClick={(e) => {
            handleProductSelection(e.target.id);
            navigateTo();
          }}
          id={product.template_id}
          className="z-50 flex p-8 w-full rounded-lg font-semibold text-gray-600 hover:text-white focus:bg-green-500 focus:text-white  hover:bg-blue-800 "
        >
          <div className="sm:flex w-full text-left z-10 pointer-events-none space-x-2 hidden">
            <div className="w-1/5 pointer-events-none">{product.form_code}</div>
            <div className="w-3/5 pointer-events-none">{product.name}</div>
            <div className="w-1/5 pointer-events-none text-right">
              ${product.totalPrice}
            </div>
          </div>

          <div className="flex flex-col w-full text-left z-10 pointer-events-none sm:hidden">
            <div className="flex justify-between">
              <div className="w-1/5 pointer-events-none">{product.form_code}</div>
              <div className="w-1/5 pointer-events-none text-right"> ${product.totalPrice}</div>
            </div>
            <div className="w-full pointer-events-none">{product.name}</div>
          </div>
        </button>
      </div>
    </>
  );
}
